export const STEPS = {
  AUTH: 'auth',
  DELIVERY: 'delivery',
  YB_PERKS: 'yb-perks',
};

export const LABEL_BY_STEP = {
  [STEPS.AUTH]: 'Sign In/Register',
  [STEPS.DELIVERY]: 'Select Delivery & Billing',
  [STEPS.YB_PERKS]: "You've Got Unlockable YB Perks!",
};

export const STEP_ORDERS = [STEPS.AUTH, STEPS.DELIVERY];

export const DELIVERY_METHODS = {
  DOORSTEP: 0,
  CNC: 1,
};

export const LABEL_BY_DELIVERY_METHOD = {
  [DELIVERY_METHODS.DOORSTEP]: 'Doorstep Delivery',
  [DELIVERY_METHODS.CNC]: 'Click & Collect',
};

export const VALIDATION_TYPE = {
  SESSION: 'session',
  DELIVERY_DATE_TIME: 'delivery_date_time',
  CLICK_AND_COLLECT: 'click_and_collect',
  ADDRESSES: 'addresses',
  PAYMENT_METHOD: 'payment_method',
  TERMS_AND_CONDITION: 'terms_and_condition',
  COUPON: 'coupon',
  PAYMENT_AMOUNT: 'payment_amount',
};

export const REQUIRED_CHECKOUT_VALIDATION_TYPES = [
  VALIDATION_TYPE.SESSION,
  VALIDATION_TYPE.CLICK_AND_COLLECT,
  VALIDATION_TYPE.DELIVERY_DATE_TIME,
  VALIDATION_TYPE.CLICK_AND_COLLECT,
  VALIDATION_TYPE.ADDRESSES,
  VALIDATION_TYPE.PAYMENT_METHOD,
  VALIDATION_TYPE.TERMS_AND_CONDITION,
  VALIDATION_TYPE.COUPON,
  VALIDATION_TYPE.PAYMENT_AMOUNT,
];
